import React, { useRef, useState } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";

import { useNavigate } from "react-router-dom";

import "../../assets/DataView/DataViewDemo.css";
import "../../assets/DataView/index.css";

import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";

import { FilterMatchMode } from "primereact/api";

export default function RevenueSummaryReport2() {
    const navigate = useNavigate();

    const ds = useRef(null);

    const [rows] = useState(20);

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const [globalFilterValue, setGlobalFilterValue] = useState("");

    const searchByReportTypeData = [
        { label: "Loan Department", value: "loan_department" },
        { label: "Project Report Department", value: "project_report_department" },
        { label: "Course Sale", value: "course_sale" },
        { label: "Software Sale", value: "software_sale" },
    ];

    const [searchByStatus, setSearchByStatus] = useState("loan_department");

    // ALL DATA
    const reportData = {
        loan_department: [
            {
                id: 1,
                month:"April",
                revenue_earned: 100,
                actual_received: 50,
                balance_due: 50,
            },
            {
                id: 1,
                month: "May",
                revenue_earned: 130,
                actual_received: 80,
                balance_due: 50,
            },
        ],

        project_report_department: [
            {
                id: 2,
                month: "April",
                revenue_earned_fee_commit: 200,
                actual_received: 120,
                balance_due: 80,
            },
        ],

        course_sale: [
            {
                id: 3,
                month: "April",
                revenue_earned_actual_recd: 500,
            },
        ],

        software_sale: [
            {
                id: 4,
                month: "April",
                revenue_earned_actual_recd: 1000,
            },
        ],
    };

    // Dynamic Data
    const branchData = reportData[searchByStatus] || [];

    const onFilter = (event) => {
        setFilters(event.filters);
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;

        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const loadMore = () => {
        console.log("Load More Clicked");
    };

    return (
        <main id="main" className="main">
            <section className="section main-color">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card-main">
                            <div className="card-body">

                                {/* HEADER */}
                                <h5 className="card-title flex">
                                    <div
                                        className="mr-3 cursor-pointer"
                                        onClick={() => navigate("/masters")}
                                    >
                                        <i className="bi bi-arrow-left-circle-fill"></i>
                                    </div>

                                    Revenue Summary Report
                                </h5>

                                {/* FILTERS */}
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginTop: 5,
                                        marginBottom: 15,
                                    }}
                                >
                                    <div className="row w-full">

                                        <div className="col-md-4 mb-2">
                                            <InputText
                                                type="text"
                                                value={globalFilterValue}
                                                onChange={onGlobalFilterChange}
                                                placeholder="Keyword Search"
                                                style={{ width: "100%" }}
                                            />
                                        </div>

                                        <div className="col-md-4 mb-2">
                                            <Dropdown
                                                style={{ width: "100%" }}
                                                options={searchByReportTypeData}
                                                value={searchByStatus}
                                                onChange={(e) =>
                                                    setSearchByStatus(e.value)
                                                }
                                                placeholder="Select Report Type"
                                            />
                                        </div>

                                    </div>
                                </div>

                                {/* TABLE */}
                                <div className="card">
                                    <DataTable
                                        value={branchData}
                                        paginator
                                        rows={rows}
                                        filters={filters}
                                        onFilter={onFilter}
                                        globalFilterFields={[
                                            "revenue_earned",
                                            "actual_received",
                                            "balance_due",
                                        ]}
                                        stripedRows
                                        responsiveLayout="scroll"
                                        className="p-datatable-gridlines"
                                    >
                                        <Column
                                            header="#"
                                            className="product-category table-design-without-btn"
                                            body={(data, options) =>
                                                options.rowIndex + 1
                                            }
                                        />

                                        <Column
                                            
                                            className="product-category table-design-without-btn"
                                            field="month"
                                            header="Month"
                                        />

                                        {/* Loan Department */}
                                        {searchByStatus === "loan_department" && (
                                            <Column
                                                field="revenue_earned"
                                                header="Revenue Earned"
                                                className="product-category table-design-without-btn"
                                            />
                                        )}

                                        {/* Project Report */}
                                        {searchByStatus ===
                                            "project_report_department" && (
                                                <Column
                                                    field="revenue_earned_fee_commit"
                                                    header="Revenue Earned Fee Commit"
                                                className="product-category table-design-without-btn"
                                                />
                                            )}

                                        {/* Course + Software */}
                                        {(searchByStatus === "course_sale" ||
                                            searchByStatus ===
                                            "software_sale") && (
                                                <Column
                                                    field="revenue_earned_actual_recd"
                                                    header="Revenue Earned"
                                                className="product-category table-design-without-btn"
                                                />
                                            )}

                                        <Column
                                            field="actual_received"
                                            header="Actual Received"
                                            className="product-category table-design-without-btn"
                                        />

                                        <Column
                                            field="balance_due"
                                            header="Balance Due"
                                            className="product-category table-design-without-btn"
                                        />
                                    </DataTable>
                                </div>

                                {/* LOAD MORE BUTTON */}
                                <div className="flex justify-content-center mt-4">
                                    <Button
                                        type="button"
                                        icon="pi pi-plus"
                                        label="Load More"
                                        onClick={loadMore}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}